import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';

import themeBarbercloud from '../../../styles/themeBarbercloud';
import themeSalonzone from '../../../styles/themeSalonzone';
import GlobalStyles from '../../../styles/GlobalStyles';
import '../../../static/fonts/fonts.css';
import '../../../static/fonts/fonts-salonzone.css';

import SEO from './seo';
import Navigation from '../navigation/navigation';

import Header from '../../sections/header';
import Features from '../../sections/features';
import Footer from '../../sections/footer';
import Pricing from '../../sections/pricing';
import References from '../../sections/references';
import AboutUs from '../../sections/aboutus';
import Contact from '../../sections/contact';
import VideoCarousel from '../../sections/video';

const Layout = ({ locale, i18nMessages, isSalonzone }) => {
  return (
    <IntlProvider locale={locale} messages={i18nMessages}>
      <ThemeProvider theme={isSalonzone ? themeSalonzone : themeBarbercloud}>
        <>
          <GlobalStyles />
          <SEO title="Home" />
          <Navigation />
          <Header />
          <Features />
          <VideoCarousel locale={locale} isSalonzone={isSalonzone} />
          <Pricing />
          {/* <References /> */}
          <AboutUs />
          <Contact />
          <Footer />
        </>
      </ThemeProvider>
    </IntlProvider>
  );
};
Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
